// ══════════════════════════════════════════════════════════════════════════════
// A.D.M Sound System — ambient drone, alert tones, AI processing sounds
// Uses Howler.js for cross-platform audio
// ══════════════════════════════════════════════════════════════════════════════

let muted = false;

// Generate synthetic audio using Web Audio API (no files needed)
function createTone(freq, duration, type='sine', vol=0.1) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ctx.currentTime);
    gain.gain.setValueAtTime(0, ctx.currentTime);
    gain.gain.linearRampToValueAtTime(vol, ctx.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch(_) {}
}

export const SoundSystem = {
  // Play a subtle alert ping
  alert(level = 'AMBER') {
    if(muted) return;
    const freqs = { RED: 880, AMBER: 660, GREEN: 440 };
    createTone(freqs[level] || 660, 0.3, 'sine', 0.08);
  },

  // AI processing click sound
  processingClick() {
    if(muted) return;
    createTone(1200, 0.05, 'square', 0.04);
  },

  // Data received pulse
  dataReceived() {
    if(muted) return;
    createTone(800, 0.1, 'sine', 0.05);
    setTimeout(() => createTone(1000, 0.08, 'sine', 0.04), 80);
  },

  // Threat escalation
  threatEscalation() {
    if(muted) return;
    [0,100,200].forEach(d => setTimeout(() => createTone(440+d*2, 0.15, 'sawtooth', 0.06), d));
  },

  // Toggle mute
  toggleMute() { muted = !muted; return muted; },
  isMuted() { return muted; },
};

export default SoundSystem;
